
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";

    @Component({
        name: "productConfig",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config
        btnloading = false

        id: any = ''
        channel_type: any = ''
        channel_id: any = ''
        base_info = {}
        operator = {}
        activated() {
            this.activeName='1'
            let { id }: any = this.$route.query
            if(id) {
                this.id = id
            }

            this.yunyingForm = {}
            this.ruleForm = {}
            this.dynamicTags = []
            this.value1 = []

            // 获取运营商
            api.getOperatorSection().then(res => {
                this.operator = res
            })

            // 调用字典接口，可能会添加新机构
            api.getDics().then((res) => {
                store.dispatch("system/addConfig", res);
                this.config = store.state.system.config
            });

            // 机构配置
            this.getJC()
            this.getManageList(this.$route.query.op_id)
        }

        // 选择客户经理
        choseOperator(val: any) {
            this.value1 = []
            this.getManageList(val)
        }

        // 选择机构类型
        orgType = ''
        choseOrgType(type: any) {
            this.orgType = type
        }

        value1 = []

        // 客户经理
        manage = []
        getManageList(op_id: any) {
            api.getManageList({op_id: op_id}).then(res => {
                this.manage = res
            })
        }


        // 基础配置
        getJC() {
            api.post('A6011', {id: this.$route.query.id}).then(res => {
                let a = this.config.outorg_section_type.find((item: any) => {return item.id == res.org_id})
                this.orgType = a.type
                this.ruleForm = {
                    name: res.name,
                    bond_type: res.bond_type,
                    org_type: res.org_type,
                    agency_type: res.agency_type,
                    contact: res.contact,
                    mobile: res.mobile,
                    prefix_code: res.prefix_code,
                    org_id: res.org_id
                }
                this.dynamicTags = res.tag ? res.tag.split(',') : []
                this.value1 = res.manager_id ? res.manager_id.split(',') : []
                this.yunyingForm = {
                    op_id: res.op_id ? res.op_id:'',
                    manager_id: res.manager_id,
                    outorg_sdk: res.outorg_sdk,
                    price_type: res.price_type,
                    // manager_id: res.manager_id,
                }
                if(res.op_id) {
                    api.getManageList({op_id: res.op_id}).then(res => {
                        this.manage = res
                    })
                }


            })
        }


        // tab切换
        activeName='1'
        handleClick(tab: any, event: any) {
            event.preventDefault(); // 阻止默认切换行为
        }

        // 基础配置
        ruleForm: any = {}
        date1: any = []

        //新增标签
        dynamicTags: any = []
        inputVisible = false
        inputValue = ''
        handleClose(tag: any) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        }
        showInput() {
            if(this.dynamicTags.length >= 4) {
                this.$message.warning('最多增加4个标签')
                return
            }
            this.inputVisible = true;
            this.$nextTick(() => {
                (this.$refs as any).saveTagInput.$refs.input.focus();
            });
        }
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        }

        submitForm() {
            let ruleForm = this.ruleForm
            this.btnloading = true
            api.post('A6009', {id: this.id, ...ruleForm, scenario: 'step_one', tag: this.dynamicTags.join(',')}).then(res => {
                this.getJC()
                this.$message.success('操作成功')

                setTimeout(() => {
                    this.activeName = '2'
                }, 1000)
            }).finally(() => {
                this.btnloading = false
            })

        }


        // 机构配置
        tableData = []
        total = 0
        search = {
            product_id: '',
            pagination: {
                page: 0,
                pageSize: 20
            }
        }

        // 运营配置
        yunyingForm: any = {}
        saveLoading = false
        saveYunying() {
            if(!this.yunyingForm.op_id) {
                this.$message.warning('请选择运营商')
                return
            }
            this.saveLoading = true
            let obj = {
                id: this.$route.query.id,
                userid: store.state.user.user.id,
                tag: this.dynamicTags.join(','),
                scenario: 'step_two',
                op_id: this.yunyingForm.op_id,
                manager_id: this.value1.join(','),
                price_type: this.yunyingForm.price_type,
                outorg_sdk: this.yunyingForm.outorg_sdk
            }
            api.post('A6009', obj).then(res => {
                this.$message.success('操作成功')
            }).finally(() => {
                this.saveLoading = false
            })

        }


    }
